import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Row, Card, Col, Collapse, Container, Button, Form, Table, Badge, Spinner, InputGroup, Pagination } from 'react-bootstrap';
import UFiles from './UFiles'
import './Checker.css'
import TableToExcel from '../helpers/Excel';
import { getFormattedDate } from '../helpers/functions';
import Pages from './Pages'

const NOTENAME = ["nsigned", "ntz", "npolice", "narmy", "nhealth", "nwork", "npen2", "npen4", "npen5", "nform", "nbank", "nadvise", "ndoc", "npermit", "nfamily", "nalready", "nextra"]
const HORAAH = ["usigned", "utz", "uhealth", "uwork", "upen2", "upen4", "upen5", "uform", "ubank", "uadvise", "udoc", "ufamily", "ualready", "uextra"]
const EZER = ["usigned", "utz", "upolice", "uarmy", "uhealth", "upen2", "upen5", "uform", "ubank", "upermit", "ufamily", "uextra"]
const HEBREW = {
    usigned: 'סט מסמכים מלא וחתום ע"י העובד, מנהל ביה"ס והמפקח  מטעם "בני יוסף".',
    utz: "צילום ת.ז. + ספח.",
    upolice: "אישור ממשטרת ישראל על העדר מניעה להעסקה במוסדות חינוך.",
    uarmy: 'ותק צבאי – (שירות צבאי, שירות לאומי, שירות אזרחי) יש להעלות אשור על תקופת שירות בחודשים חתום על ידי מנהל המוסד וחותמת המוסד, וכן דוח מעסיקים מבטוח לאומי – ',
    uhealth: "אישור מרופא משפחה על מצב בריאות תקין.",
    uwork: "אישור נתוני העסקה ממשרד החינוך. (מערכת הפורטל) ",
    upen2: "נספח 2 - קרן פנסיה. ו/או נספח 3 - ביטוח מנהלים. (כולל כל המסמכים הנדרשים, בהתאם למפורט בנוהל הליך הצטרפות לפנסיה/ השתלמות/ גמל)",
    upen4: "נספח 4 - קופת גמל. (כולל כל המסמכים הנדרשים, בהתאם למפורט בנספח)",
    upen5: "נספח 5 - קרן השתלמות. (כולל כל המסמכים הנדרשים, בהתאם למפורט בנספח)",
    uform: "טופס 101. כולל כל מסמך אחר הרלוונטי לצורך חישוב השכר כגון: תאום מס, גמלת ילד נכה וכדו'",
    ubank: "צילום שיק או אישור פרטי ח-ן בנק עדכני.",
    uadvise: "במידה והעובד מיועד לתפקיד יועץ, יש להעלות אישור העסקה מהמפקח על היועצים.",
    udoc: 'במידה והעובד מיועד לתפקיד פרא רפואי, יש להעלות אישור מנהל אגף חנ"מ.',
    upermit: 'במידה והמועמד מועסק כבר כעובד הוראה ומיועד לעבודה כשרת/מזכיר יש לקבל אשור העסקה מהרב יזדי -סמנכ"ל פדגוגיה. וכן להפך.',
    ufamily: "וועדת חריגים-במידה והמועמד מצהיר על קרבת משפחה יש למלא טופס לוועדת חריגים",
    ualready: 'במקרה והמועמד מועסק כבר כעובד עזר ומיועד לעבודה כעובד הוראה יש להעלות אישור העסקה מהרב יזדי – סמנכ"ל פדגוגי.',
    uextra: "כל מסמך נוסף שתרצו להוסיף.",
}

const Checker = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [rows1, setRows1] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [spinner, setSpinner] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [pagination, setPagination] = useState([]);
    const [pagination1, setPagination1] = useState([]);
    const [pagination2, setPagination2] = useState([]);
    const [itemsPerPage] = useState(50);
    // Add separate pagination states for each section
    const [currentPageStatus1, setCurrentPageStatus1] = useState(1);
    const [currentPageStatus2, setCurrentPageStatus2] = useState(1);
    const [currentPageStatus3, setCurrentPageStatus3] = useState(1);
    const [open, setOpen] = useState(false);
    const [sendback, setSendback] = useState(false);
    const [finished, setFinished] = useState(false);
    const [id, setId] = useState(0);
    const [stat, setstat] = useState(4);
    const [edit, setedit] = useState(true);
    const [ALL, setALL] = useState([]);
    const [formdata, setFormdata] = useState({});
    const [hide, setHide] = useState(false);
    const [note, setNote] = useState({
        nsigned: '',
        ntz: '',
        npolice: '',
        narmy: '',
        nhealth: '',
        nwork: '',
        npen2: '',
        npen4: '',
        npen5: '',
        nform: '',
        nbank: '',
        nadvise: '',
        ndoc: '',
        npermit: '',
        nfamily: '',
        nalready: '',
        nextra: '',
    });
    const [checkbox, setCheckbox] = useState({
        nsigned: true,
        ntz: true,
        npolice: true,
        narmy: true,
        nhealth: true,
        nwork: true,
        npen: true,
        nform: true,
        nbank: true,
        npen2: true,
        npen4: true,
        npen5: true,
        nadvise: true,
        ndoc: true,
        npermit: true,
        nfamily: true,
        nalready: true,
        nextra: true,
    });
    const [statText, setstatText] = useState("הבקשה מאושרת");
    const [currURL, setCurrURL] = useState("");
    const [files, setFiles] = useState({});

    const init = async () => {
        try {
            const response = await axios.get("api/checker");
            if (response.status === 200) {
                setPagination(response.data.rows)
                setPagination1(response.data.rowsback)
                setPagination2(response.data.complete)
                setRows2(response.data.complete)
                setRows1(response.data.rowsback)
                setRows(response.data.rows)
                setSpinner(false)
            }
        } catch (error) {
            console.error('Error:', error);
            setSpinner(false);

            // Check if session expired (401/403) or other auth errors
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                alert('פג תוקף ההתחברות. מעביר לעמוד הבית...');
                window.location.href = '/';
            } else if (error.response && error.response.status >= 500) {
                alert('שגיאת שרת. אנא נסה שוב מאוחר יותר.');
            } else {
                alert('שגיאה בטעינת הנתונים. אנא רענן את הדף.');
            }
        }
    }

    const handleRefresh = async () => {
        setRefreshing(true);
        try {
            await init();
        } finally {
            setRefreshing(false);
        }
    };

    const handleSwitchToAdmin = async () => {
        try {
            const response = await axios.post("api/switchToAdmin");
            if (response.data.msg === "ok") {
                sessionStorage.setItem('usertype', 4);
                navigate('/admin');
            } else {
                alert("שגיאה במעבר למנהל מערכת");
            }
        } catch (error) {
            console.error("Error switching to admin:", error);
            alert("שגיאה במעבר למנהל מערכת");
        }
    };

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        const loadFileData = async () => {
            if (id > 0) {
                try {
                    const response = await axios.post("api/form/upload", { id });
                    if (response.data.msg === 'ok') {
                        const filenames = response.data.form;
                        let temp = filenames.formtype === 0 ? HORAAH : EZER;
                        setALL(temp);
                        let allFiles = {};

                        async function fetchFile(fileName, name) {
                            try {
                                const fileResponse = await axios.post(`api/uploads`, { fileName });
                                const url = fileResponse.data.url;
                                allFiles[name] = url;
                            } catch (error) {
                                console.error(`Error fetching file ${fileName}:`, error);
                                // Check for session expiration on file fetch
                                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                                    alert('פג תוקף ההתחברות. מעביר לעמוד הבית...');
                                    window.location.href = '/';
                                    return;
                                }
                                allFiles[name] = '';
                            }
                        }

                        async function processArray() {
                            for (const elem of temp) {
                                if (filenames[elem] === '') {
                                    allFiles[elem] = '';
                                } else {
                                    await fetchFile(filenames[elem], elem);
                                }
                            }
                            setFiles(allFiles);
                            setCurrURL(allFiles.usigned);
                        }

                        await processArray();

                        let userData = {};
                        let check = {};
                        let notes = {};
                        userData.fname = filenames.fname;
                        userData.lname = filenames.lname;
                        userData.tz = filenames.tz;
                        userData.cell = filenames.cell;
                        userData.mail = filenames.mail;
                        userData.sname = filenames.sname;
                        userData.formtype = filenames.formtype;

                        for (const elem of NOTENAME) {
                            if (filenames[elem] === '') {
                                check[elem] = true;
                            } else {
                                check[elem] = false;
                            }
                            notes[elem] = filenames[elem];
                        }
                        setCheckbox(check);
                        setNote(notes);
                        setFormdata(userData);
                    }
                } catch (error) {
                    console.error('Error:', error);

                    // Check if session expired (401/403) or other auth errors
                    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                        alert('פג תוקף ההתחברות. מעביר לעמוד הבית...');
                        window.location.href = '/';
                    } else if (error.response && error.response.status >= 500) {
                        alert('שגיאת שרת בטעינת נתוני הקובץ.');
                    } else {
                        alert('שגיאה בטעינת נתוני הקובץ.');
                    }
                }
            }
        };

        loadFileData();
    }, [id]);
    useEffect(() => {
        console.log(note);
        let nonotes = true;
        let prob = false;
        for (const [key, value] of Object.entries(note)) {
            if (value !== '') {
                nonotes = false;
            }
        }
        for (const [key, value] of Object.entries(checkbox)) {
            if (!value) {
                prob = true;
            }
        }
        if (nonotes && prob) {
            setHide(true)
        } else {
            setHide(false)
        }
        if (nonotes) {
            setstatText("אישור הבקשה")
            setstat(4)
        } else {
            setstatText("נא להשלים את הפרטים שהתבקשו")
            setstat(3)
        }
    }, [note, checkbox]);

    // Calculate paginated data for all sections
    // Status 1 (open section)
    const indexOfLastItemStatus1 = currentPageStatus1 * itemsPerPage;
    const indexOfFirstItemStatus1 = indexOfLastItemStatus1 - itemsPerPage;
    const currentItemsStatus1 = pagination.slice(indexOfFirstItemStatus1, indexOfLastItemStatus1);
    const totalPagesStatus1 = Math.ceil(pagination.length / itemsPerPage);

    // Status 2 (sendback section)
    const indexOfLastItemStatus2 = currentPageStatus2 * itemsPerPage;
    const indexOfFirstItemStatus2 = indexOfLastItemStatus2 - itemsPerPage;
    const currentItemsStatus2 = pagination1.slice(indexOfFirstItemStatus2, indexOfLastItemStatus2);
    const totalPagesStatus2 = Math.ceil(pagination1.length / itemsPerPage);

    // Status 3 (finished section)
    const indexOfLastItemStatus3 = currentPageStatus3 * itemsPerPage;
    const indexOfFirstItemStatus3 = indexOfLastItemStatus3 - itemsPerPage;
    const currentItemsStatus3 = pagination2.slice(indexOfFirstItemStatus3, indexOfLastItemStatus3);
    const totalPagesStatus3 = Math.ceil(pagination2.length / itemsPerPage);

    // Handle page changes for each section
    const handlePageChangeStatus1 = (pageNumber) => {
        setCurrentPageStatus1(pageNumber);
    };

    const handlePageChangeStatus2 = (pageNumber) => {
        setCurrentPageStatus2(pageNumber);
    };

    const handlePageChangeStatus3 = (pageNumber) => {
        setCurrentPageStatus3(pageNumber);
    };

    const changeFile = (i) => {
        if (files[i] !== '') {
            setCurrURL(files[i]);
        }
        if (files[i] === currURL && files[i] !== '') {
            openNew()
        }
    }
    const openNew = () => {
        window.open(currURL, '_blank');
    }
    const changeStatus = async () => {
        try {
            // Check session and handle both API calls
            const statusResponse = await axios.post("api/changestatus", { id, "status": stat });
            const noteResponse = await axios.post("api/checkernote", { id, "note": note });

            // Only proceed if both API calls were successful
            if (statusResponse.status === 200 && noteResponse.data.msg === 'ok') {
                let date = new Date();

                // Clear notes on success
                setNote({
                    nsigned: '',
                    ntz: '',
                    npolice: '',
                    narmy: '',
                    nhealth: '',
                    nwork: '',
                    npen2: '',
                    npen4: '',
                    npen5: '',
                    nform: '',
                    nbank: '',
                    nadvise: '',
                    ndoc: '',
                    npermit: '',
                    nfamily: '',
                    nalready: '',
                    nextra: '',
                });

                // Update UI state only after successful backend operations
                if (stat === 3) {
                    let fixed2 = rows.filter(row => row.id === id);
                    if (fixed2.length > 0) {
                        fixed2[0].status3date = date;
                        setRows1([...rows1, fixed2[0]]);
                        setPagination1([...rows1, fixed2[0]]);
                    }
                }
                if (stat === 4) {
                    let fixed3 = rows.filter(row => row.id === id);
                    if (fixed3.length > 0) {
                        fixed3[0].status4date = date;
                        setRows2([...rows2, fixed3[0]]);
                        setPagination2([...rows2, fixed3[0]]);
                    }
                }

                // Remove from current list
                let fixed1 = rows.filter(row => row.id !== id);
                setRows(fixed1);
                setPagination(fixed1);

                setId(0);
                setOpen(!open);
            } else {
                // Backend operation failed
                alert('שגיאה בעדכון הסטטוס. אנא נסה שוב.');
            }
        } catch (error) {
            console.error('Error:', error);

            // Check if session expired (401/403) or other auth errors
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                alert('פג תוקף ההתחברות. מעביר לעמוד הבית...');
                // Redirect to home page
                window.location.href = '/';
            } else if (error.response && error.response.status >= 500) {
                alert('שגיאת שרת. אנא נסה שוב מאוחר יותר.');
            } else {
                alert('שגיאה בעדכון הסטטוס. אנא נסה שוב.');
            }
        }
    }
    const handleChange = (name, val) => {
        setNote({ ...note, [name]: val })
    }
    const revert = async (id) => {
        try {
            const response = await axios.post("api/changestatus", { id, "status": 2 });
            if (response.status === 200) {
                init();
            } else {
                alert('שגיאה בהחזרת הסטטוס. אנא נסה שוב.');
            }
        } catch (error) {
            console.error('Error:', error);

            // Check if session expired (401/403) or other auth errors
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                alert('פג תוקף ההתחברות. מעביר לעמוד הבית...');
                window.location.href = '/';
            } else if (error.response && error.response.status >= 500) {
                alert('שגיאת שרת. אנא נסה שוב מאוחר יותר.');
            } else {
                alert('שגיאה בהחזרת הסטטוס. אנא נסה שוב.');
            }
        }
    }

    const revertToStatus1 = async (id) => {
        try {
            const response = await axios.post("api/changestatus", { id, "status": 2 });
            if (response.status === 200) {
                init();
            } else {
                alert('שגיאה בהחזרת הסטטוס לסטטוס 1. אנא נסה שוב.');
            }
        } catch (error) {
            console.error('Error:', error);

            // Check if session expired (401/403) or other auth errors
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                alert('פג תוקף ההתחברות. מעביר לעמוד הבית...');
                window.location.href = '/';
            } else if (error.response && error.response.status >= 500) {
                alert('שגיאת שרת. אנא נסה שוב מאוחר יותר.');
            } else {
                alert('שגיאה בהחזרת הסטטוס לסטטוס 1. אנא נסה שוב.');
            }
        }
    }

    const changeview = async (e, index, id) => {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData(e.target);
        let unqid;
        for (let [key, value] of formData.entries()) {
            unqid = value;
        }

        try {
            const response = await axios.post("api/checkerchangeview", { id, unqid });
            if (response.status === 200) {
                let fixedorigion = [...rows2]
                let orgindex = rows2.findIndex(obj => obj.id === id)
                fixedorigion[orgindex].view = 2
                fixedorigion[orgindex].uniqueworkerid = unqid

                let fixed = [...pagination2]
                fixed[index].view = 2
                fixed[index].uniqueworkerid = unqid
                setRows2(fixedorigion)
                setPagination2(fixed)
            } else {
                alert('שגיאה בעדכון הגישה. אנא נסה שוב.');
            }
        } catch (error) {
            console.error('Error:', error);

            // Check if session expired (401/403) or other auth errors
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                alert('פג תוקף ההתחברות. מעביר לעמוד הבית...');
                window.location.href = '/';
            } else if (error.response && error.response.status >= 500) {
                alert('שגיאת שרת. אנא נסה שוב מאוחר יותר.');
            } else {
                alert('שגיאה בעדכון הגישה. אנא נסה שוב.');
            }
        }
    }
    const showUploads = (id, edit = 1) => {
        if (edit === 1) {
            setedit(true)
        } else {
            setedit(false)
        }
        if (sendback) {
            setSendback(!sendback)
        }
        if (finished) {
            setFinished(!finished)
        }

        if (id > 0) {
            setId(id);
            setOpen(false)
        } else {
            setOpen(!open)
            setId(0);
        }
        init();
    }
    const showTable = () => {
        if (open) {
            setOpen(!open)
        }
        if (finished) {
            setFinished(!finished)
        }
        setId(0);
        setSendback(!sendback)
        init();
    }
    const showFinished = () => {
        if (open) setOpen(false);
        if (sendback) setSendback(false);
        setId(0);
        setFinished(!finished);
        setCurrentPageStatus3(1); // Reset to first page when opening
        init();
    };
    const handleCheck = (name, special) => {
        console.log(name, special);
        setCheckbox({
            ...checkbox,
            [name]: !special
        })
        if (!special) {
            setNote({
                ...note,
                [name]: ''
            })
        }
    }

    // Function to extract specific columns from the data
    const extractSpecificColumns = (data) => {
        return data.map((row) => {
            const { id, fname, lname, tz, formtype, uniqueworkerid, sname, semel, status4date, father, sec, clean, sayat, social, doc, class1, class2, class3, class4, class5, class6 } = row;
            const statusTranslated = formtype === 0 ? "עובד הוראה" : "עובד עזר";
            const date = new Date(status4date)

            // Map database fields to Hebrew roles
            const roleMapping = {
                father: "אב בית / שרת",
                sec: "מזכיר/ה",
                clean: "עובד/ת ניקיון",
                sayat: "סייע/ת",
                social: 'עו"ס',
                doc: "רופא",
                class1: "מחנך/כת כיתה",
                class2: "מורה מקצועי/ת",
                class3: "שילוב/ מקדמת/ סל אישי",
                class4: "פרא רפואי",
                class5: "ייעוץ/ניהול/הדרכה/הנחיה",
                class6: "אחר"
            };

            // Find all roles based on which fields are true/set
            let roles = [];
            const roleFields = { father, sec, clean, sayat, social, doc, class1, class2, class3, class4, class5, class6 };
            for (const [key, value] of Object.entries(roleFields)) {
                if (value && value !== 0 && value !== false) {
                    const roleName = roleMapping[key];
                    if (roleName) {
                        roles.push(roleName);
                    }
                }
            }
            const role = roles.join(", ");

            const display = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
            return {
                "#": id,
                "שם פרטי": fname,
                "שם משפחה": lname,
                "תעודת זהות": tz,
                "סוג טופס": statusTranslated,
                "מספר עובד ייחודי": uniqueworkerid,
                "שם בית הספר": sname,
                "סמל": semel,
                "תפקיד": role,
                "סטטוס 4 לתאריך": display,
            };
        });
    };

    let specificColumnsData = extractSpecificColumns(pagination2);

    return (
        <>
            <Container>
                <Row className='pt-3 pb-2'>
                    <Col xs={12} className='d-flex justify-content-end'>
                        <Button
                            variant="outline-info"
                            onClick={handleSwitchToAdmin}
                            size="sm"
                            className="me-2"
                        >
                            מעבר למנהל מערכת
                        </Button>
                        <Button
                            variant="outline-primary"
                            onClick={handleRefresh}
                            disabled={refreshing}
                            size="sm"
                        >
                            {refreshing ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    מרענן...
                                </>
                            ) : (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise me-2" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                    </svg>
                                    רענן נתונים
                                </>
                            )}
                        </Button>
                    </Col>
                </Row>
                <Row className='pb-4'>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                        <Card role='button' className={open ? 'alert alert-primary shadow p-0 m-0 h-100' : 'shadow-sm h-100'} onClick={() => showUploads(0)}
                            aria-controls="open"
                            aria-expanded={open}>
                            <Card.Title className='m-3'>סטטוס 1 בקשות שהועלו וממתינות לבדיקתי - {spinner ? (<>
                                <Spinner animation="border" role="status" size="sm">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </>) : rows.length}</Card.Title>
                        </Card>
                    </Col>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4} onClick={() => showTable()}>
                        <Card role='button' className={sendback ? 'alert alert-primary shadow p-0 m-0 h-100' : 'shadow-sm h-100'}>
                            <Card.Title className='m-3'>סטטוס 2 בקשות שהעברתי למוסד להשלמת מסמכים במוסד - {spinner ? (<>
                                <Spinner animation="border" role="status" size="sm">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </>) : rows1.length}</Card.Title>
                        </Card>
                    </Col>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4} onClick={() => showFinished()}>
                        <Card role='button' className={finished ? 'alert alert-primary shadow p-0 m-0 h-100' : 'shadow-sm h-100'}>
                            <Card.Title className='m-3'>סטטוס 3 בקשות שאישרתי - {spinner ? (<>
                                <Spinner animation="border" role="status" size="sm">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </>) : rows2.length}</Card.Title>
                        </Card>
                    </Col>
                </Row>
                <Collapse in={open}>
                    <div id="open">
                        <Row className='mb-1'>
                            <Col xs={0} md={10} lg={10} xl={10} xxl={10} className=''></Col>
                            <Col xs={12} md={2} lg={2} xl={2} xxl={2} className=''>
                                <Form.Control type="text" placeholder="חיפוש" onChange={(e) => {
                                    const filtered = rows.filter(i => `${i.fname} ${i.lname}${i.tz}${i.formtype}${i.sname}${i.semel}${i.formtype === 0 ? 'עובד הוראה' : 'עובד עזר'}`.includes(e.target.value));
                                    setPagination(filtered);
                                    setCurrentPageStatus1(1); // Reset to first page on search
                                }} />
                            </Col>
                        </Row>
                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>תאריך חזרה למוסד</th>
                                    <th>תאריך הגשה</th>
                                    <th>שם</th>
                                    <th>תז</th>
                                    <th>תפקיד</th>
                                    <th>שנה</th>
                                    <th>בית ספר</th>
                                    <th>סוג</th>
                                    <th>סמל</th>
                                    <th>הצג</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItemsStatus1.map(i => {
                                    let date = new Date(i.status2date)
                                    let display = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
                                    let date1 = new Date(i.status3date)
                                    let display1 = date1.getDate() + '/' + (date1.getMonth() + 1) + '/' + date1.getFullYear() + ' ' + ('0' + date1.getHours()).slice(-2) + ':' + ('0' + date1.getMinutes()).slice(-2);
                                    return (
                                        <tr key={i.id}>
                                            <td>{display1 === "1/1/1970 02:00" ? "הגשה ראשונית" : display1}</td>
                                            <td>{display}</td>
                                            <td>{i.fname + ' ' + i.lname}</td>
                                            <td>{i.tz}</td>
                                            <td>{i.formtype === 0 ? 'עובד הוראה' : 'עובד עזר'}</td>
                                            <td>{i.year}</td>
                                            <td title={i.sname}>{i.sname}</td>
                                            <td>{i.Mtype}</td>
                                            <td>{i.semel}</td>
                                            <td className='text-center' onClick={() => showUploads(i.id, 1)}><svg role="button" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-lines-fill" viewBox="0 0 16 16">
                                                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
                                            </svg></td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                        <Pages
                            currentPage={currentPageStatus1}
                            totalPages={totalPagesStatus1}
                            onPageChange={handlePageChangeStatus1}
                        />
                    </div>
                </Collapse>
                <Collapse in={sendback}>
                    <div id="sendback">
                        <Row className='mb-1'>
                            <Col xs={0} md={10} lg={10} xl={10} xxl={10} className=''></Col>
                            <Col xs={12} md={2} lg={2} xl={2} xxl={2} className=''>
                                <Form.Control type="text" placeholder="חיפוש" onChange={(e) => {
                                    const filtered = rows1.filter(i => `${i.fname} ${i.lname}${i.tz}${i.formtype}${i.sname}${i.semel}${i.formtype === 0 ? 'עובד הוראה' : 'עובד עזר'}`.includes(e.target.value));
                                    setPagination1(filtered);
                                    setCurrentPageStatus2(1); // Reset to first page on search
                                }} />
                            </Col>
                        </Row>
                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>תאריך הגשה</th>
                                    <th>תאריך חזרה למוסד</th>
                                    <th>שם</th>
                                    <th>תז</th>
                                    <th>תפקיד</th>
                                    <th>שנה</th>
                                    <th>בית ספר</th>
                                    <th>סמל</th>
                                    <th>הצג</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItemsStatus2.map(i => {
                                    let date = new Date(i.status3date)
                                    let display = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
                                    let date1 = new Date(i.status2date)
                                    let display1 = date1.getDate() + '/' + (date1.getMonth() + 1) + '/' + date1.getFullYear() + ' ' + ('0' + date1.getHours()).slice(-2) + ':' + ('0' + date1.getMinutes()).slice(-2);

                                    return (
                                        <tr key={i.id}>
                                            <td>{display1}</td>
                                            <td>{display}</td>
                                            <td>{i.fname + ' ' + i.lname}</td>
                                            <td>{i.tz}</td>
                                            <td>{i.formtype === 0 ? 'עובד הוראה' : 'עובד עזר'}</td>
                                            <td>{i.year}</td>
                                            <td title={i.sname}>{i.sname}</td>
                                            <td>{i.semel}</td>
                                            <td className='text-center' onClick={() => showUploads(i.id, 2)}><svg role="button" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-lines-fill" viewBox="0 0 16 16">
                                                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
                                            </svg></td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </Table>
                        <Pages
                            currentPage={currentPageStatus2}
                            totalPages={totalPagesStatus2}
                            onPageChange={handlePageChangeStatus2}
                        />
                    </div>
                </Collapse>
                <Collapse in={finished}>
                    <div id="finished">

                        <Row className='mb-1'>
                            <Col xs={0} md={8} lg={9} xl={9} xxl={9} className='p-0'></Col>
                            <Col xs={12} md={2} lg={2} xl={2} xxl={2} className='p-0'>
                                <Form.Control type="text" placeholder="חיפוש" onChange={(e) => {
                                    const filtered = rows2.filter(i =>
                                        `${i.fname} ${i.lname}${i.tz}${i.formtype}${i.sname}${i.uniqueworkerid}${i.semel}${i.formtype === 0 ? 'עובד הוראה' : 'עובד עזר'}`.includes(e.target.value)
                                    );
                                    setPagination2(filtered);
                                    setCurrentPageStatus3(1); // Reset to first page on search
                                }}
                                />
                            </Col>
                            <Col xs={12} md={2} lg={1} xl={1} xxl={1} className='pe-0'>
                                <TableToExcel data={specificColumnsData} fileName={`data_${getFormattedDate()}`} /></Col>

                        </Row>
                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>תאריך סטטוס 4</th>
                                    <th>שם</th>
                                    <th>תז</th>
                                    <th>תפקיד</th>
                                    <th>שנה</th>
                                    <th>בית ספר</th>
                                    <th>סוג</th>
                                    <th>סמל</th>
                                    <th>הצג</th>
                                    <th>גישה למחלקות</th>
                                    <th>מספר עובד</th>
                                    <th>החזר לסטטוס 1</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItemsStatus3.map((i, index) => {
                                    let date = new Date(i.status4date)
                                    let display = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
                                    return (
                                        <tr key={i.id}>
                                            <td>{display}</td>
                                            <td>{i.fname + ' ' + i.lname}</td>
                                            <td>{i.tz}</td>
                                            <td>{i.formtype === 0 ? 'עובד הוראה' : 'עובד עזר'}</td>
                                            <td>{i.year}</td>
                                            <td title={i.sname}>{i.sname.length > 13 ? i.sname.substring(0, 13) + "..." : i.sname}</td>
                                            <td>{i.Mtype}</td>
                                            <td>{i.semel}</td>
                                            <td className='text-center' onClick={() => showUploads(i.id, 2)}><svg role="button" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-lines-fill" viewBox="0 0 16 16">
                                                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
                                            </svg></td>
                                            <td className='text-center'>
                                                {i.view === 1 ? (
                                                    <Form onSubmit={(e) => changeview(e, index, i.id)}>
                                                        <InputGroup className="" dir='ltr'>
                                                            <Button type="submit" variant="outline-primary">
                                                                פתיחת גישה
                                                            </Button>
                                                            <Form.Control dir='rtl' required className='inpwidth' autoComplete="off" name="workid" type="number" placeholder="מס' עובד"
                                                            />
                                                        </InputGroup>
                                                    </Form>
                                                ) : (
                                                    <Form onSubmit={(e) => changeview(e, index, i.id)}>
                                                        <InputGroup className="" dir='ltr'>
                                                            <Button type="submit" variant="outline-danger">
                                                                עדכן
                                                            </Button>
                                                            <Form.Control dir='rtl' required className='inpwidth' autoComplete="off" name="workid" type="number" placeholder="מס' עובד"
                                                            />
                                                        </InputGroup>
                                                    </Form>
                                                )}

                                            </td>
                                            <td>{
                                                i.uniqueworkerid ? i.uniqueworkerid :
                                                    <Badge bg="danger" role="button" onClick={() => revert(i.id)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-backspace-reverse-fill" viewBox="0 0 16 16">
                                                            <path d="M0 3a2 2 0 0 1 2-2h7.08a2 2 0 0 1 1.519.698l4.843 5.651a1 1 0 0 1 0 1.302L10.6 14.3a2 2 0 0 1-1.52.7H2a2 2 0 0 1-2-2V3zm9.854 2.854a.5.5 0 0 0-.708-.708L7 7.293 4.854 5.146a.5.5 0 1 0-.708.708L6.293 8l-2.147 2.146a.5.5 0 0 0 .708.708L7 8.707l2.146 2.147a.5.5 0 0 0 .708-.708L7.707 8l2.147-2.146z" />
                                                        </svg>
                                                    </Badge>
                                            }
                                            </td>
                                            <td className='text-center'>
                                                <Badge bg="primary" role="button" onClick={() => revertToStatus1(i.id)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
                                                        <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
                                                    </svg>
                                                </Badge>
                                            </td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </Table>
                        <Pages
                            currentPage={currentPageStatus3}
                            totalPages={totalPagesStatus3}
                            onPageChange={handlePageChangeStatus3}
                        />
                    </div>
                </Collapse>
                {(id > 0) ? (
                    <>
                        <span><p><b>שם: {formdata.fname + " " + formdata.lname} תז: {formdata.tz} טל: {formdata.cell} מייל: {formdata.mail} מועמד לבית ספר {formdata.sname} כ{formdata.formtype === 0 ? 'עובד הוראה' : 'עובד עזר'} בשנת {formdata.year}</b></p></span>
                        <Row className='mb-2'>
                            <Col xs={12} md={4} lg={4} xl={4} xxl={4} className='scroll'>
                                <Table striped bordered>
                                    <thead>
                                        <tr>
                                            <th>תקין</th>
                                            <th>לחץ לפתיחת קובץ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ALL.map((item, i) => (
                                            <React.Fragment key={item}>
                                                <tr>
                                                    <td className='text-center'>
                                                        <Form.Check type="checkbox" name={"n" + item.slice(1)} disabled={!edit} onChange={(e) => handleCheck(e.target.name, checkbox["n" + item.slice(1)])} checked={note["n" + item.slice(1)] === '' && checkbox["n" + item.slice(1)]} />
                                                    </td>
                                                    <td onClick={() => changeFile(item)}>
                                                        <p className="text-end">{`${i + 1}) ${HEBREW[item]} `}<i>{files[item] === '' ? 'לא הועלה קובץ' : ''}</i></p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2} className={(note["n" + item.slice(1)] === '' && checkbox["n" + item.slice(1)]) ? "d-none" : ''}>
                                                        <Form.Group className="" controlId={note["n" + item.slice(1)]}>
                                                            <Form.Control type="text" value={note["n" + item.slice(1)]} disabled={!edit} name={"n" + item.slice(1)} onChange={(e) => handleChange(e.target.name, e.target.value)} placeholder="הערה" />
                                                        </Form.Group>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                            <Col xs={12} md={8} lg={8} xl={8} xxl={8}><UFiles key={currURL} url={currURL} /></Col>
                        </Row>
                        <Button className={hide ? 'invisible mb-2' : "mb-2"} variant={stat === 3 ? "danger" : "warning"} disabled={!edit} onClick={changeStatus}>{statText}</Button>
                    </>
                ) : (<></>)
                }
                {/*<hr />
                <div className='text-center'>
                    <Button variant='primary'>הוספת משתמש</Button>
            </div>*/}
            </Container>
        </>
    )
}
export default Checker